
import React from 'react';

export default function ResidentialServices() {
  const services = [
    {
      icon: 'ri-home-4-line',
      title: 'Complete Home Renovations',
      description:
        'End-to‑to residential renovation services covering every room in your home. We manage demolition, construction, plumbing, electrical, and finishing to deliver a seamless transformation.',
    },
    {
      icon: 'ri-layout-masonry-line',
      title: 'Kitchen Remodelling',
      description:
        'Bespoke kitchen designs with premium countertops, custom cabinetry, and state‑of‑the‑art appliance integration. Marble, granite, and engineered stone specialists.',
    },
    {
      icon: 'ri-drop-line',
      title: 'Bathroom Renovations',
      description:
        'Luxury bathroom transformations featuring walk‑in showers, freestanding baths, heated flooring, and premium tile work with waterproofing guarantees.',
    },
    {
      icon: 'ri-building-line',
      title: 'Structural Alterations',
      description:
        'Licensed structural modifications including load‑bearing wall removal, room extensions, second‑storey additions, and foundation reinforcement with full engineering compliance.',
    },
    {
      icon: 'ri-paint-brush-line',
      title: 'High‑End Finishes',
      description:
        'Premium plastering, bespoke joinery, custom mouldings, feature walls, and decorative finishes that elevate your home to luxury standards.',
    },
    {
      icon: 'ri-landscape-line',
      title: 'Outdoor Living Spaces',
      description:
        'Designer patios, entertainment areas, braai rooms, and pool surrounds built with premium materials for the ultimate Johannesburg lifestyle.',
    },
  ];

  return (
    <section className="py-16 md:py-24 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-20">
          <p className="text-xs font-semibold tracking-widest text-[#D4AF37] uppercase mb-4">
            What We Offer
          </p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#2A2A2A] leading-tight mb-4">
            Residential Renovation{' '}
            <span className="font-serif text-[#D4AF37]">Services</span>
          </h2>
          <p className="text-base lg:text-lg text-gray-600 max-w-2xl mx-auto">
            Every home renovation project is managed by our licensed contractors
            with full accountability, transparent pricing, and on‑time delivery.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {services.map((service) => (
            <article
              key={service.title}
              className="group bg-[#FDFBF7] rounded-2xl p-6 md:p-8 hover:shadow-xl transition-all duration-400 border border-transparent hover:border-[#D4AF37]/20"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-[#D4AF37]/10 rounded-2xl mb-4 md:mb-6 group-hover:bg-[#D4AF37]/20 transition-colors">
                <i className={`${service.icon} text-xl md:text-2xl text-[#D4AF37]`}></i>
              </div>
              <h3 className="text-lg md:text-xl font-bold text-[#2A2A2A] mb-2 md:mb-3">
                {service.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
